import { motion } from "framer-motion";

import fi from "./assets/Fi.webp";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#F9FFDD] py-20 px-4 sm:px-6">
      <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* Left Column – 60% with animation */}
        <motion.div
          className="w-full lg:w-[60%]"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h5 className="text-[#212129] text-sm font-semibold uppercase mb-3 tracking-wide">
            Finance Service
          </h5>

          <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
            Brighten your financial <br className="hidden sm:block" /> future by
            today
          </h2>

          <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
            Take full control of your money with powerful financial tools,
            <br />
            personalized expert guidance and bold, easy-to-use solutions — all{" "}
            <br />
            designed to help you make smarter decisions and start seeing results{" "}
            <br />
            today.{" "}
          </p>
        </motion.div>

        {/* Right Column – 40% with animation */}
        <motion.div
          className="w-full lg:w-[40%] flex justify-center"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          <img
            src={fi}
            alt="Finance Illustration"
            className="w-full max-w-[500px] h-auto object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
